import archie from "../assets/archie-pfp.png";
import "./Archie.scss";
import { useState, useContext, useEffect } from "react";
import { AppContext } from "../context";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ClaimAllButton from "./ClaimAllButton";

const Claim = () => {
  const [userInput, setUserInput] = useState("");
  const { wallet, connect } = useContext(AppContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const submitCode = async (userInput: string, walletAddress: string) => {
    const apiUrl =
      "https://j8ybc7n0qc.execute-api.eu-central-1.amazonaws.com/prod/";

    try {
      await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          answers: [userInput],
          walletAddress,
        }),
      });
    } catch (error) {
      console.error("Error submitting data to API:", error);
    }
  };

  const setup = () => {
    if (!wallet) {
      connect();
    }
  };

  useEffect(() => {
    setup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet]);

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container">
          <div className="archie-title-container">
            <div className="archie-title" id="title">
              Claim
            </div>
            <br />
            <div className="archie-info mb-6" id="bodyText">
              Can't get enough GMs? Don't worry Archie's got your back! Join
              our&nbsp;
              <a className="archie-discord" href="https://discord.gg/replyguys">
                discord
              </a>
              &nbsp; to get involved with Archie's events!.
            </div>
          </div>

          <div className="archie-main-container">
            <div className="archie-rg">
              <img className="archie-image" src={archie} alt="reply guy" />
            </div>
            <div className="archie-text-columns">
              <div className="archie-speech-bubble-container">
                <div className="archie-speech-bubble">
                  <p className="archie-text">
                    Hi, I am <span className="primary-text">Archie</span>! As a
                    core member of the Reply Guys, I'm on a mission to bring
                    excitement and rewards to our Discord community.
                  </p>
                </div>
              </div>
              <div className="archie-speech-bubble-container">
                <div className="archie-speech-bubble">
                  <p className="archie-text second-paragraph">
                    I'm a cheeky lad with a razor-sharp wit, known for my
                    sarcastic quips and lighthearted banter. I might come off as
                    a bit brash at times, but I'm always up for a good laugh and
                    love keeping the conversation flowing.
                  </p>
                </div>
              </div>
              <div className="archie-speech-bubble-container">
                <div className="archie-speech-bubble">
                  <p className="archie-text">
                    I genuinely want to make the Reply Guys experience as
                    enjoyable and rewarding as possible. So, buckle up and get
                    ready for a wild ride with me, Archie, the most amusing and
                    mischievous reply guy around!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="archie-code-input-container mb-6">
          <input
            type="text"
            className="code-input"
            placeholder="Enter your code here"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          />
        </div>

        <div className="archie-submit-button-container">
          <button
            className="button is-primary archie-submit-button"
            id="button"
            onClick={() => {
              if (wallet) {
                submitCode(userInput, wallet);
                setIsModalOpen(true);
              }
            }}
            disabled={!wallet}
          >
            Submit
          </button>
        </div>
      </div>

      <div className={`modal ${isModalOpen ? "is-active" : ""}`}>
        <div
          className="modal-background"
          onClick={() => setIsModalOpen(false)}
        ></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Submission Successful</p>
            <button
              className="delete"
              aria-label="close"
              onClick={() => setIsModalOpen(false)}
            ></button>
          </header>
          <section className="modal-card-body">
            <p>
              Your code is being sent. If your code is valid, you will be able
              to claim your GM shortly.
            </p>
          </section>
        </div>
      </div>
      <ClaimAllButton />
      <br />
      <Footer />
    </>
  );
};

export default Claim;
